module.exports = __webpack_public_path__ + "static/media/cloud.736ee415.svg";